import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app';
import { AuthStateService } from '@core/services/auth/auth-state';
import { appConfig } from 'app/app.config';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    appRef.injector.get(AuthStateService).loadTokenFromStorage();
    appRef.injector.get(AuthStateService).loadTemporaryTokenFromStorage();
    appRef.injector.get(AuthStateService).loadRefreshTokenFromStorage();
  })
  .catch((err) => console.error(err));
